import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, NgForm, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MortgageEligibilityInfoService } from 'app/services/api/mortgageEligibilityInfo/mortgageEligibilitInfo.service';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogMortgageEligibilityCopyDataData {
    id: number;
}

@Component({
    selector: 'dialog-mortgage-eligibility-copy-data',
    templateUrl: 'dialog-mortgage-eligibility-copy-data.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogMortgageEligibilityCopyDataComponent extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: FormGroup;
    formEnabled = true;
    loading: boolean = false;
    sourceInfoId: number;
    state: 'pristine' | 'valid' | 'invalid' = 'pristine';

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogMortgageEligibilityCopyDataComponent>,
        private formBuilder: UntypedFormBuilder,
        private mortgageEligibilityService: MortgageEligibilityInfoService,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogMortgageEligibilityCopyDataData
    ) {
        super(dialogRef);
        this.initForm();
    }

    initForm = () => {
        this.form = this.formBuilder.group({
            searchString: new FormControl('', [Validators.required]),
        });

        this.form.controls['searchString'].valueChanges
            .pipe(debounceTime(300))
            .pipe(distinctUntilChanged())
            .subscribe((value) => {
                if (value.length == 0) {
                    this.state = 'pristine';
                    return;
                }
                this.findExistingMortgageEligibilityInfo(value);
            });
    };

    findExistingMortgageEligibilityInfo = (searchString) => {
        this.loading = true;
        this.state = 'pristine';
        this.mortgageEligibilityService
            .getMortgageEligibilityInfoExists(searchString)
            .then((res) => {
                this.sourceInfoId = res.id;
                this.state = 'valid';
            })
            .catch((err) => {
                this.sourceInfoId = null;
                this.state = 'invalid';
            })
            .finally(() => {
                this.loading = false;
            });
    };

    submit = () => {
        this.mortgageEligibilityService.updateMortgageElgibilityInfoFromCopy(this.data.id, this.sourceInfoId).then((res) => {
            this.dialogRef.close(true);
        });
    };

    close = () => {
        this.dialogRef.close(false);
    };
}
